const actionTypeIdentifier = '3D74G5FC-BE8A-4799-A14F-56B8A8AD3ZA6';

export const setFilterData = `SET-FILTER-DATA-${actionTypeIdentifier}`;
export const removeFilterData = `REMOVE-FILTER-DATA-${actionTypeIdentifier}`;
export const resetFilterData = `RESET-FILTER-DATA-${actionTypeIdentifier}`